import React, { Component } from "react";
import Functions from "../../src/functions";

class Tabs extends Component {
  state = {
    name: "",
    id: "",
    placeholder: "",
    value: "",
    defaultValue: "",
    loaded: false,
    editable: true,
    attributes: "",
    events: {},
  };

  constructor(props) {
    super(props);

    this.customUI = this.customUI.bind(this);

    let events = {};
    if (this.props.property.events) {
      Object.keys(this.props.property.events).map((itm, idx) => {
        this[itm] = this.props.property.events[itm];
        this[itm] = this[itm].bind(this);
        events[itm] = this[itm];
      });
    }

    let defaultValue = "";
    if (this.props.property.defaultValue) {
      defaultValue = this.props.property.defaultValue;
    }

    let tabs = this.props.property.configuration
      ? this.props.property.configuration.tabs
      : {};

    Object.keys(tabs).map((element) => {
      tabs[element]["tabuuid"] = Functions.key();
    });

    this.state = {
      events: events,
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      defaultValue: this.props.value ? this.props.value : defaultValue,
      tabs: tabs,
    };
  }

  componentDidMount() {
    this.setState({
      attributes: this.props.property.attributes,
      name: this.props.property.alias,
      placeholder: this.props.property.placeholder
        ? this.props.property.placeholder
        : "",
      editable:
        this.props.property.editable != null
          ? this.props.property.editable
          : this.state.editable,
      customUI: this.props.property.customUI,

      useCustomUI:
        typeof this.props.property.useCustomUI !== "undefined"
          ? this.props.property.useCustomUI
          : true,
    });
    if (this.didMount) {
      this.didMount();
    }
  }

  customUI(control) {
    if (this.state.customUI && this.state.useCustomUI == true) {
      this.state.customUI = this.state.customUI.bind(this);
      return this.state.customUI({ control: control, object: this });
    }

    return control;
  }

  render() {
    let components = this.props.manager.templateRef.current.state.data[0];

    let control = (
      <div className="tab-container">
        <ul className=" nav nav-tabs nav-overflow " role="tablist">
          {Object.keys(this.state.tabs).map((itm, idx) => {
            let tab = this.state.tabs[itm];

            let activeClass = "";

            if (idx == 0) {
              activeClass = "active show";
            }

            return (
              <li className="nav-item pointer" key={"tab-" + tab.tabuuid + 1}>
                <div
                  className={"nav-link " + activeClass}
                  data-toggle="tab"
                  href={"#tab-" + tab.tabuuid + 1}
                  role="tab"
                  id={"tab-link"}
                >
                  <div
                    style={{
                      height: "49px",
                      width: "267px",
                      position: "relative",
                    }}
                    className="text-black"
                  >
                    <span className="text-dark">{tab.label}</span>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>

        <div className="tab-content">
          {Object.keys(this.state.tabs).map((itm, idx) => {
            let tab = this.state.tabs[itm];
            let activeClass = "";

            if (idx == 0) {
              activeClass = "active show";
            }

            let ControlUI = Functions.getTemplate("control");

            return (
              <div
                className={"tab-pane  " + activeClass}
                role="tabpanel"
                id={"tab-" + tab.tabuuid + 1}
                key={"content-" + tab.tabuuid + 1}
              >
                <div className="container-fluid  animated fadeIn  pt-3 pl-4">
                  {tab.properties.map((citm, cidx) => {
                    if (components[citm]) {
                      return (
                        <ControlUI
                          control={components[citm]}
                          key={tab.tabuuid + "-" + citm}
                        ></ControlUI>
                      );
                    }
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );

    return control;
  }
}

export default Tabs;
